import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import "./ImagePdfTools.css";
import { useState, useEffect } from "react";
import { ImageConverterAPI } from "../../Services/APIService";

export const FORMAT_OPTIONS = [{optionName : "JPG ➜ PNG",targetFormat: "png", inputFormat: ["jpg"],enableQuality : false},
{optionName : "PNG ➜ JPG",targetFormat: "jpg", inputFormat: ["png"],enableQuality : true},
{optionName : "TIFF ➜ PNG",targetFormat: "png", inputFormat: ["tiff"],enableQuality : false},
{optionName : "TIFF ➜ JPG",targetFormat: "jpg", inputFormat: ["tiff"],enableQuality : true},
{optionName : "PNG/JPG ➜ TIFF",targetFormat: "tiff", inputFormat: ["png","jpg"],enableQuality : false}];

export function resolveFormatOption(formatSelection) {
    if (!formatSelection) {
        return FORMAT_OPTIONS[3];
    }

    if (typeof formatSelection === "object") {
        return formatSelection;
    }

    return FORMAT_OPTIONS.find((option) => option.optionName === formatSelection) || FORMAT_OPTIONS[3];
}

function ImageTools() {
    const toolFav = { toolName: 'Image Converter', Iconpath: "/FileCodeRaw.svg" };
    const [selectedFormat, setSelectedFormat] = useState(FORMAT_OPTIONS[3]);
    const [quality, setQuality] = useState(86);
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [outputUrl, setOutputUrl] = useState("");
    const [outputFileName, setOutputFileName] = useState("");

    

    useEffect(() => {
        return () => {
            if (outputUrl) {
                window.URL.revokeObjectURL(outputUrl);
            }
        };
    }, [outputUrl]);

    

    const selectedOption = resolveFormatOption(selectedFormat);

    const getAcceptedFileTypes = () => {
        const formats = selectedOption?.inputFormat || ["jpg"];

        return formats.flatMap((format) => {
            switch (format?.toLowerCase()) {
                case "jpg":
                case "jpeg":
                    return ["image/jpeg"];
                case "png":
                    return ["image/png"];
                case "tiff":
                case "tif":
                    return ["image/tiff"];
                default:
                    return [];
            }
        });
    };

    const isAcceptedFile = (file) => {
        const acceptedTypes = getAcceptedFileTypes();
        if (!acceptedTypes.length) return true;

        const fileType = file.type?.toLowerCase();
        const extension = (file.name.split(".").pop() || "").toLowerCase();

        return acceptedTypes.some((type) => {
            if (type === "image/jpeg") {
                return fileType === "image/jpeg" || fileType === "image/jpg" || ["jpg", "jpeg"].includes(extension);
            }
            if (type === "image/png") {
                return fileType === "image/png" || extension === "png";
            }
            if (type === "image/tiff") {
                return fileType === "image/tiff" || ["tif", "tiff"].includes(extension);
            }
            return false;
        });
    };

    const getTargetFormat = () => {
        return selectedOption?.targetFormat || "jpg";
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        const validFiles = selectedFiles.filter(isAcceptedFile);
        const invalidFiles = selectedFiles.filter((file) => !isAcceptedFile(file));

        if (invalidFiles.length) {
            window.alert(`Only ${selectedOption.inputFormat.join(", ")} files are allowed for this conversion.`);
        }

        const updatedFiles = validFiles.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setFiles(updatedFiles);
    };

    const handleProcess = async () => {
        if (!files.length) return;

        try {
            setLoading(true);

            const formData = new FormData();
            files.forEach((item) => {
                formData.append("files", item.file);
            });
            formData.append("targetFormat", getTargetFormat());

            const response = await ImageConverterAPI(formData);

            // 1. Revoke the older URL to free browser memory
            if (outputUrl) {
                window.URL.revokeObjectURL(outputUrl);
            }

            // 2. Safely capture the blob
            const blob = response.data;

            // 3. Generate the new preview URL
            const blobUrl = window.URL.createObjectURL(blob);

            setOutputUrl(blobUrl);
            setOutputFileName(`converted.${getTargetFormat()}`);

        } catch (error) {
            console.error("Image conversion failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setFiles([]);
        setOutputUrl("");
        setOutputFileName("");
    }

    return (
        <Col>
            <ToolHeader title="Image Converter" description="Convert and resize images all processing happens in your browser" toolFav={toolFav} />


            <Row className='Formatter'>
                <div className="converter-wrapper">
                    {/* FORMAT TABS */}
                    <div className="format-tabs">
                        {FORMAT_OPTIONS.map((item) => (
                            <button
                                key={item.optionName}
                                className={`format-btn ${selectedOption.optionName === item.optionName ? "active" : ""
                                    }`}
                                onClick={() => setSelectedFormat(item)}
                            >
                                {item.optionName}
                            </button>
                        ))}
                    </div>

                    {/* TITLE */}
                    <div className="converter-title-card">
                        <h3>{selectedOption.optionName}</h3>
                        <p>
                            Convert {selectedOption.inputFormat.join(", ")} images to{" "}
                            {selectedOption.targetFormat} format
                        </p>
                    </div>

                    {/* QUALITY */}
                   {selectedOption.enableQuality && (
                        <div className="quality-wrapper">
                            <span>JPG Quality: {quality}%</span>
                            <input
                                className="quality-slider"
                                type="range"
                                min={1}
                                max={100}
                                value={quality}
                                onChange={(e) => setQuality(e.target.value)}
                            />
                        </div>
                    )}

                    {/* DROP ZONE */}
                    <label className="drop-zone">
                        <input
                            type="file"
                            multiple
                            hidden
                            accept={getAcceptedFileTypes().join(",")}
                            onChange={handleFileChange}
                        />

                        <div className="upload-content">
                            <div className="upload-icon"> 
                                <svg
                                    className="dmc-upload-icon"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M12 16V4M12 4L7 9M12 4L17 9" />
                                    <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                                </svg></div>

                            <p>Click to select or drop images here</p>

                            <span>Accepted: {selectedOption.inputFormat.join(", ")}</span>
                        </div>
                    </label>

                    {/* FILE COUNT */}
                    {!!files.length && (
                        <div className="file-count">{files.length} file loaded</div>
                    )}

                    {/* FILE PREVIEW */}
                    <div className="action-buttons">
                        <button className="clear-btn" onClick={() => handleClear()}>
                            Clear
                        </button>

                        <button
                            className="process-btn"
                            onClick={handleProcess}
                            disabled={loading}
                        >
                            {loading ? "Processing..." : "Process"}
                        </button>
                    </div>
                    <div className="preview-grid">
                        {!outputUrl  && files.map((item, index) => (
                            <div className="preview-card" key={index}>
                                <button
                                    className="remove-btn"
                                    onClick={() => {
                                        const updated = [...files];
                                        updated.splice(index, 1);
                                        setFiles(updated);
                                    }}
                                >
                                    ✕
                                </button>

                                <img src={item.preview} alt="preview" />

                                <div className="file-info">
                                    <p>{item.file.name}</p>

                                    <span>
                                        {(item.file.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {outputUrl && (
                        <div className="converted-output">
                            <h4>Converted Output</h4>
                            <div className="converted-image-card">
                                <img
                                    src={outputUrl}
                                    alt="Converted"
                                    className="converted-image"
                                /> 
                                <div className="converted-file-info">
                                <p>{outputFileName}</p>
                                <div className="download-container">
                                    <p className="file-size">✓ {(new Blob([outputUrl]).size / 1024).toFixed(2)} KB</p>    
                                    <a className="download-link" href={outputUrl} download={outputFileName}>
                                        <button className="download-btn">Download</button>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ACTION BUTTONS */}

                </div>
            </Row>
        </Col>
    );
}

export default ImageTools;
